
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whats-new-in-epic-react-v2",
      function () {
        return require("private-next-pages/whats-new-in-epic-react-v2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whats-new-in-epic-react-v2"])
      });
    }
  